import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_zoom_out.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconZoomOut = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconZoomOut;
